// 农业域名
// 测试服务器地址（内部访问）：https://200.200.200.50
// 测试服务器地址（外部访问）：https://dp.clife.net
// 预发布服务器地址：https://test.api.clife.cn
// 生产服务器地址：http://10.8.9.13
// https://dp.clife.net/v4

// 公共平台域名
// https://api.clife.cn 正式
// https://dp.clife.net 测试内网

// 公共平台接口
export const publicHost = "https://api.clife.cn";
// 智慧农业接口
export const host = "";
// api版本
export const apiVersion = "v4";
// 注:部分post接口需要header,部分不需要,单独设置
export const headers = {
  "content-Type": "application/json"
};
export const postHeaders = {
  "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
};
export const project = "/web/agriculture";
export const projectOps = "/web/ops";
export const projectCommon = "/web/manage";
export const projectSource = "/web/source";
export const projecAgronomist = "/web/agronomist";
export const pollution = "/web/pollute";
export const projectPest = "/web/pest";
/* 紫金项目 */
export const projectZj = "/web/customize";
